exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bsh-tab button[data-v-0dc748df]{background-color:#fff}.cl-blue[data-v-0dc748df]{color:#00f}.nowrap[data-v-0dc748df]{white-space:nowrap}", ""]);

// exports
